import React, { useEffect, useState } from 'react';

import { useAppSelector } from 'store/hooks';
import { Raffle } from 'api/raffle/raffle_detail';
import { DiscordFillBrand, Globe, TwitterFillBrand } from 'lib/lucky-x-icons-2';

interface ICoreInfoProps {}

const SocialInfo: React.FC<ICoreInfoProps> = ({}) => {
  const { raffleInfo } = useAppSelector((state) => state.raffleDetails);
  const [raffle, setRaffle] = useState<Raffle>();

  useEffect(() => {
    setRaffle(raffleInfo);
  }, [raffleInfo]);

  if (
    !raffle?.project?.twitter_screen_name &&
    !raffle?.project?.dc_invite_link &&
    !raffle?.project?.website
  ) {
    return null;
  }

  return (
    <div className="flex items-center justify-center gap-6 text-neutral-100 md:justify-start">
      {!!raffle?.project?.twitter_screen_name && (
        <a
          href={`https://twitter.com/${raffle?.project?.twitter_screen_name}`}
          target="_blank"
          rel="noreferrer"
        >
          <div className="flex h-8 w-8 items-center justify-center rounded-full bg-[#00A3FF] hover:bg-opacity-90 ">
            <TwitterFillBrand color="#FCFCFD" size={24} />
          </div>
        </a>
      )}
      {!!raffle?.project?.dc_invite_link && (
        <a
          href={raffle?.project?.dc_invite_link}
          target="_blank"
          rel="noreferrer"
        >
          <div className="flex h-8 w-8 items-center justify-center rounded-full bg-[#5865F2] hover:bg-opacity-90">
            <DiscordFillBrand color="#FCFCFD" size={24} />
          </div>
        </a>
      )}
      {!!raffle?.project?.website && (
        <a href={raffle?.project?.website} target="_blank" rel="noreferrer">
          <div className="flex h-8 w-8  items-center justify-center rounded-full  bg-neutral-500 group">
            <Globe size={24} className='text-neutral-400 group-hover:text-neutral-100' />
          </div>
        </a>
      )}
    </div>
  );
};

export default SocialInfo;
